/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Place_LabelInputs */

const en_us2_gyms_place_label = /** @type {(inputs: Gyms_Place_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What kind of place is it?`)
};

const pt_br2_gyms_place_label = /** @type {(inputs: Gyms_Place_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que tipo de lugar é?`)
};

const es_419_gyms_place_label = /** @type {(inputs: Gyms_Place_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tipo de lugar es?`)
};

const pt_pt2_gyms_place_label = /** @type {(inputs: Gyms_Place_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que tipo de sítio é?`)
};

const fr_fr2_gyms_place_label = /** @type {(inputs: Gyms_Place_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel type de lieu ?`)
};

const de_de2_gyms_place_label = /** @type {(inputs: Gyms_Place_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was für ein Ort ist das?`)
};

const it_it2_gyms_place_label = /** @type {(inputs: Gyms_Place_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che tipo di posto è?`)
};

/**
* | output |
* | --- |
* | "What kind of place is it?" |
*
* @param {Gyms_Place_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_place_label = /** @type {((inputs?: Gyms_Place_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Place_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_place_label(inputs)
	if (locale === "es-419") return es_419_gyms_place_label(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_place_label(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_place_label(inputs)
	if (locale === "de-DE") return de_de2_gyms_place_label(inputs)
	if (locale === "it-IT") return it_it2_gyms_place_label(inputs)
	return en_us2_gyms_place_label(inputs)
});
export { gyms_place_label as "gyms.place_label" }